(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ldw-orders-runtime"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.LdwOrders) return;
  const config = document.getElementById('LdwOrdersConfig');
  if (!config) return;
  const c = config.dataset;
  let busy = false;
  const gifts = cart => cart.items.filter(item => item.properties?._ldw_add_on === 'Gift-ready order');
  const giftUrl = () => `${c.cartUrl}?view=gift-message`;
  const isCartPage = () => location.pathname.replace(/\/$/, '') === c.cartUrl.replace(/\/$/, '');
  function error(message, scope) {
    const target = scope?.querySelector('.ldw-order-error') || document.getElementById('LdwOrdersError');
    if (target) { target.textContent = message || ''; target.hidden = !message; }
  }
  async function request(url, body) {
    const response = await fetch(url, body ? {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)} : {headers:{Accept:'application/json'},cache:'no-store'});
    const result = await response.json();
    if (!response.ok || result.status || result.errors) throw new Error(result.description || result.message || (typeof result.errors === 'string' ? result.errors : c.error));
    return result;
  }
  const getCart = () => request(`${c.cartUrl}.js`);
  function eventPromise(action, lines) {
    const EventType = window.StandardEvents?.CartLinesUpdateEvent;
    if (!EventType) return null;
    const deferred = EventType.createPromise();
    deferred.promise.catch(() => {});
    document.dispatchEvent(new EventType({action, context:'cart', lines, promise:deferred.promise}));
    return deferred;
  }
  async function withLock(scope, action) {
    if (busy) { error(c.busy, scope); return; }
    busy = true;
    error('', scope);
    error('');
    const buttons = [...(scope?.querySelectorAll('button') || [])];
    const previouslyDisabled = buttons.map(button => button.disabled);
    buttons.forEach(button => { button.disabled = true; button.setAttribute('aria-busy','true'); });
    try { await action(); }
    catch (err) { error(err.message || c.error, scope?.isConnected ? scope : null); }
    finally {
      busy = false;
      buttons.forEach((button,i) => {button.disabled = previouslyDisabled[i];button.removeAttribute('aria-busy');});
    }
  }
  async function refresh(cart, openDrawer = false) {
    if (isCartPage()) { location.reload(); return; }
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) { location.assign(c.cartUrl); return; }
    const url = new URL(c.cartUrl, location.origin);
    url.searchParams.set('sections','cart-drawer,cart-icon-bubble');
    const sections = await request(url.toString());
    if (!sections['cart-drawer'] || !sections['cart-icon-bubble']) { location.assign(c.cartUrl); return; }
    drawer.classList.toggle('is-empty',cart.item_count === 0);
    drawer.setActiveElement?.(document.activeElement);
    drawer.renderContents({sections});
    if (!openDrawer && cart.item_count === 0) drawer.classList.add('is-empty');
  }
  const groupLines = (cart,group,child) => cart.items.filter(item => item.properties?._ldw_group === group && (child ? item.properties?._ldw_add_on === 'Hook upgrade' : !!item.properties?._ldw_hook_variant));
  const totalQuantity = lines => lines.reduce((total,item) => total + item.quantity,0);
  function checkPairs(cart) {
    const groups = new Set(cart.items.filter(item => item.properties?._ldw_hook_variant || item.properties?._ldw_add_on === 'Hook upgrade').map(item => item.properties._ldw_group));
    for (const group of groups) {
      const parents = groupLines(cart,group,false), children = groupLines(cart,group,true);
      if (!parents.length || totalQuantity(parents) !== totalQuantity(children) || children.some(child => String(child.variant_id) !== String(parents[0].properties._ldw_hook_variant))) throw new Error(c.pairError);
    }
  }
  async function setGroupQuantity(cart,group,child,target) {
    for (let attempt=0;attempt<20;attempt++) {
      const lines = groupLines(cart,group,child);
      const total = totalQuantity(lines);
      if (total === target) return cart;
      if (!lines.length) throw new Error(c.pairError);
      const line = lines[0];
      cart = await request(c.changeUrl,{id:line.key,quantity:Math.max(0,line.quantity + target - total)});
    }
    throw new Error(c.pairError);
  }
  async function addProduct(form) {
    const scope = form.querySelector('.ldw-product-customisation');
    const personal = form.querySelector('.js-ldw-personalisation');
    if (personal) {
      personal.value = personal.value.trim();
      personal.setCustomValidity(personal.value && personal.value.length <= 24 ? '' : c.personalError);
    }
    if (!form.reportValidity()) return;
    await withLock(form, async () => {
      const data = new FormData(form);
      const select = form.querySelector('.js-ldw-hook-choice');
      const option = select?.selectedOptions[0];
      const upgrade = option?.dataset.upgradeVariant;
      if (option?.disabled) throw new Error(c.error);
      const properties = {};
      for (const [key,value] of data.entries()) if (key.startsWith('properties[') && key.endsWith(']')) properties[key.slice(11,-1)] = value;
      const id = Number(data.get('id'));
      const quantity = Number(data.get('quantity') || 1);
      if (!id || !Number.isInteger(quantity) || quantity < 1) throw new Error(c.error);
      const main = {id,quantity,properties};
      if (data.get('selling_plan')) main.selling_plan = data.get('selling_plan');
      const items = [main];
      if (upgrade) {
        const group = crypto.randomUUID();
        properties._ldw_group = group;
        properties._ldw_hook_variant = String(upgrade);
        properties['Dispatch time'] = c.dispatch;
        items.push({id:Number(upgrade),quantity,parent_id:id,properties:{_ldw_group:group,_ldw_add_on:'Hook upgrade','Applied to':scope.dataset.ldwProductTitle,'Hook choice':option.value}});
      }
      const deferred = eventPromise('add',items.map(item => ({merchandiseId:String(item.id),quantity:item.quantity})));
      try {
        await request(c.addUrl,{items});
        const cart = await getCart();
        if (upgrade) {
          checkPairs(cart);
          if (totalQuantity(groupLines(cart,properties._ldw_group,false)) !== quantity) throw new Error(c.pairError);
        }
        deferred?.resolve({cart:window.StandardEvents.CartLinesUpdateEvent.createCartFromAjaxResponse(cart)});
        await refresh(cart,true);
      } catch (err) {
        deferred?.reject(err);
        if (upgrade) {
          // Shopify may partially add a multi-item request when stock is short.
          // Roll back only this newly generated group, preserving the existing basket.
          let cart = await getCart();
          for (let attempt=0;attempt<20;attempt++) {
            const line = groupLines(cart,properties._ldw_group,false)[0] || groupLines(cart,properties._ldw_group,true)[0];
            if (!line) break;
            cart = await request(c.changeUrl,{id:line.key,quantity:0});
          }
          throw new Error(c.error);
        }
        throw err;
      }
    });
  }
  function syncGiftChoice(form) {
    const needsMessage = form.elements.gift_option.value !== 'none';
    form.querySelector('[data-ldw-message-fields]').hidden = !needsMessage;
    for (const field of [form.elements.message,form.elements.checked_message]) {
      field.disabled = !needsMessage;
      field.required = needsMessage;
      field.setCustomValidity('');
    }
    form.elements.checked_message.checked = false;
  }
  async function removeGiftLines() {
    let cart = await getCart();
    for (let attempt=0;attempt<20;attempt++) {
      const line = gifts(cart)[0];
      if (!line) return cart;
      await request(c.changeUrl,{id:line.key,quantity:0});
      cart = await getCart();
    }
    throw new Error(c.error);
  }
  async function saveGift(form,destination) {
    const choice = form.elements.gift_option.value;
    if (!['none','basic','premium'].includes(choice)) return;
    const input = form.elements.message;
    input.value = input.value.trim();
    input.setCustomValidity(choice === 'none' || (input.value && input.value.length <= 250) ? '' : c.giftRequired);
    if (!form.reportValidity()) return;
    if (choice !== 'none' && !form.elements.checked_message.checked) return;
    await withLock(form, async () => {
      let cart = await getCart();
      if (!cart.item_count) throw new Error(c.giftMissing);
      checkPairs(cart);
      const variant = Number(form.dataset.premiumVariant);
      if (choice === 'premium' && !variant) throw new Error(c.giftMissing);
      const lines = gifts(cart);
      if (choice === 'premium') {
        const properties = {_ldw_add_on:'Gift-ready order','Gift message':input.value,'Gift message option':'Premium','_ldw_message_checked':'yes'};
        if (lines.length === 1 && Number(lines[0].variant_id) === variant) {
          await request(c.changeUrl,{id:lines[0].key,quantity:1,properties:{...lines[0].properties,...properties}});
        } else {
          await removeGiftLines();
          await request(c.addUrl,{items:[{id:variant,quantity:1,properties}]});
        }
      } else {
        await removeGiftLines();
      }
      const attributes = {'Gift message option':choice === 'none' ? '' : choice,'Gift message':choice === 'none' ? '' : input.value,'Gift message checked':choice === 'none' ? '' : 'Yes','Paid gift message':choice === 'premium' ? 'Yes' : ''};
      await request(c.updateUrl,{attributes});
      cart = await getCart();
      const saved = gifts(cart);
      if (choice === 'premium' && (saved.length !== 1 || saved[0].quantity !== 1 || saved[0].properties['Gift message'] !== input.value)) throw new Error(c.error);
      if (choice !== 'premium' && saved.length) throw new Error(c.error);
      if ((cart.attributes?.['Gift message'] || '') !== attributes['Gift message'] || (cart.attributes?.['Gift message option'] || '') !== attributes['Gift message option']) throw new Error(c.error);
      location.assign(destination === 'cart' ? c.cartUrl : `${c.rootUrl}checkout`);
    });
  }
  async function checkout() {
    await withLock(null, async () => {
      const cart = await getCart();
      checkPairs(cart);
      if (cart.item_count) location.assign(giftUrl());
    });
  }
  function updateQuantity(component,line,quantity) {
    const row = component.querySelector(`#CartItem-${line}`) || component.querySelector(`#CartDrawer-Item-${line}`);
    if (!row?.dataset.ldwGroup && !row?.dataset.ldwAddon) return false;
    withLock(row, async () => {
      const cart = await getCart();
      const item = cart.items.find(item => item.key === row.dataset.ldwLineKey);
      if (!item) throw new Error(c.error);
      if (item.properties?._ldw_add_on === 'Hook upgrade') throw new Error(c.pairError);
      if (item.properties?._ldw_add_on === 'Gift-ready order' && quantity !== 0) quantity = 1;
      const group = item.properties?._ldw_group;
      const originalTotal = group ? totalQuantity(groupLines(cart,group,false)) : 0;
      const targetTotal = originalTotal - item.quantity + quantity;
      let next = await request(c.changeUrl,{id:item.key,quantity});
      if (item.properties?._ldw_hook_variant) {
        try {
          next = await setGroupQuantity(next,group,true,targetTotal);
          checkPairs(next);
        } catch (err) {
          if (quantity > 0) {
            next = await setGroupQuantity(await getCart(),group,false,originalTotal);
            await setGroupQuantity(next,group,true,originalTotal);
          }
          await refresh(await getCart(),true);
          throw err;
        }
      }
      await refresh(next,true);
    });
    return true;
  }
  document.addEventListener('change', event => {
    if (event.target.matches('[data-ldw-gift-form] [name=gift_option]')) syncGiftChoice(event.target.form);
  });
  document.addEventListener('input', event => {
    if (event.target.matches('.js-ldw-personalisation, [data-ldw-gift-form] textarea')) event.target.setCustomValidity('');
    if (event.target.matches('[data-ldw-gift-form] textarea')) event.target.form.elements.checked_message.checked = false;
  });
  document.addEventListener('submit', event => {
    const form = event.target;
    if (form.matches('[data-ldw-gift-form]')) {
      event.preventDefault();event.stopImmediatePropagation();saveGift(form,event.submitter?.value);return;
    }
    if (form.querySelector('.ldw-product-customisation')) {
      event.preventDefault();event.stopImmediatePropagation();addProduct(form);return;
    }
    if (event.submitter?.name === 'checkout') {
      event.preventDefault();event.stopImmediatePropagation();checkout();
    }
  },true);
  document.addEventListener('click', event => {
    const button = event.target.closest('[name="checkout"],a[href="/checkout"]');
    if (button) {event.preventDefault();event.stopImmediatePropagation();checkout();}
  },true);
  window.LdwOrders = {updateQuantity};
})();
  } catch(e) { console.error(e); }
})();

})();
